import { render, staticRenderFns } from "./ExpiredOffer.vue?vue&type=template&id=460c8fa0&"
import script from "./ExpiredOffer.vue?vue&type=script&lang=js&"
export * from "./ExpiredOffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports